import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import PsContext from "../../../../context";
import { ServiceUrl } from "../../../../utils/serviceUrl";
import axios from "axios";
import { IMAGES } from "../../../../utils/data";
import { baseUrl } from "../../../../utils";

const CertificateUploading = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [newPhoto, setNewPhoto] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  const fileReaderChange = (e) => {
    try {
      let file = e.target.files[0];
      if (!file) return;

      let totalsize = file.size;
      let mz = props.minSize / 1000;
      let mx = props.maxSize / 1000;

      if (totalsize < props.minSize) {
        toast.error("File size must be greater than " + mz + " KB");
        setSelectedFileName(""); // clear filename
        return;
      }

      if (totalsize > props.maxSize) {
        toast.error("File size must be less than " + mx + " KB");
        setSelectedFileName(""); // clear filename
        return;
      }

      setSelectedFile(file);
      setSelectedFileName(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (readerEvent) => {
        setImagePreview(readerEvent.target.result);

        // ✅ Auto upload after file is read
        setTimeout(() => {
          uploadFiles(file);
        }, 100);
      };
    } catch (err) {
      console.error(err);
    }
  };

  const uploadFiles = (fileToUpload) => {
    setLoader(true);
    context.setLoader(true);

    const form = new FormData();
    form.append("i__apiCode", context.user.api_code);
    form.append("i__userId", context.user.user_id);
    form.append("i__userCode", context.user.user_code);
    form.append("i__fileName", props.fileName);
    form.append("i___file", fileToUpload || selectedFile);

    axios
      .post(ServiceUrl.PG.UPLOAD_FILE, form)
      .then((res) => {
        if (res.data.status === "1") {
          toast.success(res.data.message || "Success");
          setNewPhoto(false);
          setSelectedFile(null);
          setImagePreview(null);
          context.setLoader(false);
          if (props.onSuccess) props.onSuccess();
        } else {
          toast.error(res.data.message || "Error");
          context.setLoader(false);
        }
      })
      .catch((error) => {
        toast.error("Upload failed");
        context.setLoader(false);
        console.error(error);
      });
  };

  const getFile = () => {
    return imagePreview || (props.filePath && props.filePath.length > 5)
      ? IMAGES.ICON_VIEW_FILE.default
      : IMAGES.ICON_SELECT_FILE.default;
  };

  const getOpenFile = () => {
    return newPhoto && newPhoto.length > 5
      ? newPhoto
      : props.filePath
      ? baseUrl +
        ServiceUrl.PG.VIEW_CERTIFICATE +
        "?api_code=" +
        context.user.api_code +
        "&field_name=" +
        props.fileName
      : "";
  };

  return (
    <div>
      <Form
        action=""
        method="post"
        encType="multipart/form-data"
        id="frm_PhotoUpload"
      >
        <Row className="border-bottom py-3">
          <Col md={8}>
            <b>{props.title}</b>
            <div className="upload_info mt-15">{props.content}</div>
          </Col>
          <Col md={4}>
            <center>
              <a href={getOpenFile()} target="_blank" rel="noreferrer">
                <img
                  src={getFile()}
                  alt="View File"
                  style={{ width: "80px", cursor: "pointer" }}
                />
              </a>
              <br />
              <input
                type="file"
                name="file"
                id={props.fileName}
                className="inputfile mt-2"
                onChange={(e) => {
                  fileReaderChange(e);
                }}
                accept={props.accept || ".png,.jpg,.jpeg,.pdf"}
              />
              <label htmlFor={props.fileName}>Choose a file</label>
              {selectedFileName && (
                <div className="mt-1 small text-muted">{selectedFileName}</div>
              )}
            </center>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CertificateUploading;
